module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "second-layer add-button-wrapper"
  }, [_vm._l((_vm.scenario.parameters.dynamicQuestions), function(parameter, index) {
    return _c('div', {
      key: parameter.key
    }, [(_vm.scenario.parameters.dynamicQuestions.length != index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Вопрос опроса " + _vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.dynamicQuestions.length == index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Заключительное сообщение")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": false,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, false)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", false)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, true)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", true)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.text),
        expression: "parameter.text"
      }],
      staticClass: "textarea",
      domProps: {
        "value": (parameter.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "text", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control is-grouped"
    }, [_c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.genAudio(index)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoading) ? _c('div', {
      staticClass: "loader spinner"
    }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicSpeaker),
        expression: "tmp.dynamicTmp[index].dynamicSpeaker"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.speakerList), function(speaker) {
      return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicEmotion),
        expression: "tmp.dynamicTmp[index].dynamicEmotion"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.emotionList), function(emotion) {
      return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
      attrs: {
        "size": "small",
        "value": _vm.tmp.dynamicTmp[index].dynamicSpeed,
        "min": 0.1,
        "step": 0.1,
        "max": 3
      },
      on: {
        "change": function($event) {
          _vm.tmp.dynamicTmp[index].dynamicSpeed = $event
        }
      }
    }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.dynamicTmp[index].dynamicSpeed) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }), _c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Загрузить из файла"
      },
      on: {
        "click": function($event) {
          return _vm.clickLoadAudio(parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: ("load-audio-" + (parameter.key)),
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "name": "load-audio",
        "type": "file",
        "accept": ".wav,.mp3"
      },
      on: {
        "input": function($event) {
          return _vm.loadAudio(index, parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Записать с микрофона"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(index, parameter.key, '', '')
        }
      }
    }), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "button-center"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined add-new",
    on: {
      "click": _vm.addNewParameter
    }
  }, [_vm._v("+")])])], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73698c7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/ScenarioInterviewAFewQuestions.vue
// module id = 463
// module chunks = 40